<div class="flex h-full flex-col">
  @let ctBatch = this.ctBatchStoreService.ctBatch | async;
  @if (ctBatch) {
    <ct-shared-header [ctBatch]="ctBatch"></ct-shared-header>
  }
  <main class="min-h-0 flex-1 pb-[36px]">
    <router-outlet></router-outlet>
  </main>
</div>
<p-toast position="bottom-center"></p-toast>
<shared-core-toast-container />
